import { render, staticRenderFns } from "./mainCategory.vue?vue&type=template&id=723d5b63&scoped=true"
import script from "./mainCategory.vue?vue&type=script&lang=js"
export * from "./mainCategory.vue?vue&type=script&lang=js"
import style0 from "./mainCategory.vue?vue&type=style&index=0&id=723d5b63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723d5b63",
  null
  
)

export default component.exports